import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
// material
import { enUS, zhCN } from '@mui/material/locale';
import i18n from '../utils/lenguage/config';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'ENG',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/united-kingdom.svg'
  },
  {
    label: 'CHI',
    value: 'ch',
    systemValue: zhCN,

    icon: '/static/icons/china.svg'
  }
];

export default function useLocales(): {
  onChangeLang: (newlang: string) => void;
  translate: TFunction;
  currentLang: typeof LANGS[number];
  allLang: typeof LANGS;
} {
  const { t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

  const handleChangeLanguage = (newlang: string): void => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
